import * as React from "react";
import { Box, Button, Alert, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { useMediaQuery } from "@mui/material";

const Banner = ({ message, url, openAlert }) => {
  console.log('Props reçues dans Banner:', { message, url, openAlert });

  const navigate = useNavigate();
  const [open, setOpen] = React.useState(true);

  const isMobile = useMediaQuery("(max-width:767px)");

  // styles
  const bannerContainer = {
    width: 0,
    height:0
  }
  const innerBanner = {
    position: "fixed",
    right: "23px",
    bottom: "29px",
  }
  const bannerInnerStyles = {
    "& .MuiAlert-action" : {
      margin: "0",
      "& .MuiBox-root" : {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }
    }
  }
  const questionBtn = {
    minWidth: "inherit",
    width: "43px",
    height: "43px",
    background: "#299CDB",
    borderRadius: "100%",
    boxShadow: "1px 1px 10px 1px rgba(0, 0, 0, 0.03)",
    "&.MuiButtonBase-root": {
      "&:hover" : {
        background: "#0f4982",
      }
    }
  }

  const block = {
     width: "100%", display: "flex", justifyContent: "flex-end"
  }
  const none = {
    display: "none"
  }

  React.useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);

  console.log('État du composant Banner:', { open, isMobile });

  return (
    <Box sx={bannerContainer}>
      <Box sx={innerBanner}>
        <Collapse in={open} sx={{maxWidth: "460px", width: "100%", ...bannerInnerStyles}}>
          <Alert
            severity="warning"
            action={
              <Box>
                <Link as={Link} to={url} style={{paddingRight: 16}}>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Compléter
                  </span>
                </Link>

                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              </Box>
            }
          >
            {message}
          </Alert>
        </Collapse>
        <Box sx={!open ? block : none}>
          <Button
            disabled={open}
            onClick={() => {
              setOpen(true);
            }}
            sx={questionBtn}
          >
            <QuestionMarkIcon sx={{color: "#fff"}} />
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Banner;
